var render = function () {
  var _vm$asset, _vm$assignedUserInfo, _vm$assignedUserInfo2, _vm$asset2, _vm$asset3, _vm$assignedUserInfo3, _vm$assignedUserInfo4, _vm$asset4, _vm$asset5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [((_vm$asset = _vm.asset) === null || _vm$asset === void 0 ? void 0 : _vm$asset.status) == 'Assigned' ? [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Asset Is Assigned!")]), _c('div', {
    staticClass: "alert-body"
  }, [_c('span', [_vm._v("This asset is already assigned to "), _c('b', [_vm._v(_vm._s((_vm$assignedUserInfo = _vm.assignedUserInfo) === null || _vm$assignedUserInfo === void 0 ? void 0 : _vm$assignedUserInfo.name) + " (" + _vm._s((_vm$assignedUserInfo2 = _vm.assignedUserInfo) === null || _vm$assignedUserInfo2 === void 0 ? void 0 : _vm$assignedUserInfo2.email) + ")")]), _vm._v(".")]), _c('br'), _c('span', [_vm._v(" Release this asset first to assign it to another user. ")])])])] : ((_vm$asset2 = _vm.asset) === null || _vm$asset2 === void 0 ? void 0 : _vm$asset2.status) == 'Damaged' ? [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Asset Is Damaged!")]), _c('div', {
    staticClass: "alert-body"
  }, [_c('span', [_vm._v(" You cannot use this asset ")])])])] : ((_vm$asset3 = _vm.asset) === null || _vm$asset3 === void 0 ? void 0 : _vm$asset3.status) == 'Available' ? [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Asset Is Available!")]), _c('div', {
    staticClass: "alert-body"
  }, [_c('span', [_vm._v("You can assign this asset to a user ")]), _c('br'), _vm.assignedUserInfo ? [_c('span', [_vm._v("This asset was last assigned to "), _c('b', [_vm._v(_vm._s((_vm$assignedUserInfo3 = _vm.assignedUserInfo) === null || _vm$assignedUserInfo3 === void 0 ? void 0 : _vm$assignedUserInfo3.name) + " (" + _vm._s((_vm$assignedUserInfo4 = _vm.assignedUserInfo) === null || _vm$assignedUserInfo4 === void 0 ? void 0 : _vm$assignedUserInfo4.email) + ")")]), _vm._v(".")])] : _vm._e()], 2)])] : _vm._e(), _c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_c('b-form-input', {
    staticClass: "d-inline-block mr-sm-1 mb-1 mb-sm-0",
    attrs: {
      "placeholder": "Search By Assigned User..",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), ((_vm$asset4 = _vm.asset) === null || _vm$asset4 === void 0 ? void 0 : _vm$asset4.status) == 'Available' ? [_vm.$permissionAbility(_vm.ASSET_REPAIR_HISTORY_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Assign ")])] : _vm._e()] : _vm._e(), ((_vm$asset5 = _vm.asset) === null || _vm$asset5 === void 0 ? void 0 : _vm$asset5.status) == 'Assigned' ? [_vm.$permissionAbility(_vm.ASSET_REPAIR_HISTORY_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.releaseAsset
    }
  }, [_vm._v(" Release ")])] : _vm._e()] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "compactMode": "",
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'assigned_date',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row2, _props$row3;
        return [props.column.field === 'format_assigned_to' ? [_c('UserCard', {
          attrs: {
            "user": props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.user_id
          }
        })] : _vm._e(), props.column.field === 'format_assigned_date' ? [_c('div', [_c('span', [_vm._v(_vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.assigned_date)))]), _c('br'), _c('span', [_vm._v(" " + _vm._s(_vm.formatDateTime(props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.assigned_date)))])])] : _vm._e(), props.column.field === 'format_purpose' ? _c('div', {
          staticClass: "text-center"
        }, [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row4;
              return _vm.showDescriptionModal((_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.purpose);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)], 1) : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.ASSET_REPAIR_HISTORY_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.ASSET_REPAIR_HISTORY_DELETE, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)] : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '20', '50']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "description-modal",
      "centered": "",
      "title": "Purpose",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDescriptionModal
    }
  }, [_c('b-card-text', [_vm._v(" " + _vm._s(_vm.modalDescription) + " ")])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-asset-assign-user-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit History' : 'Assign Asset To User',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "assetAssignUserValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Assigned Employee ",
      "label-for": "user_id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "assigned employee",
      "vid": "user_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "id": "user-id",
            "placeholder": "Assign an Employee",
            "options": _vm.userIdOption,
            "reduce": function reduce(user) {
              return user.id;
            },
            "label": "name"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.assignedUserId,
            callback: function callback($$v) {
              _vm.assignedUserId = $$v;
            },
            expression: "assignedUserId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Assign Date Time",
      "label-for": "assigned-date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "assign date",
      "vid": "assigned_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "assigned_date",
            "state": errors.length > 0 ? false : null,
            "locale": "en-US",
            "place": "",
            "config": {
              enableTime: true,
              dateFormat: 'Y-m-d H:i:S '
            },
            "placeholder": "Set Assign Date Time"
          },
          model: {
            value: _vm.assignedDate,
            callback: function callback($$v) {
              _vm.assignedDate = $$v;
            },
            expression: "assignedDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.modelType == 'editModel' ? [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Return Date",
      "label-for": "returned-date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "return date",
      "vid": "returned_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-datepicker', {
          attrs: {
            "id": "returned-date",
            "locale": "en-US",
            "reset-button": "",
            "today-button": "",
            "close-button": "",
            "placeholder": "Select Return Date"
          },
          model: {
            value: _vm.returnedDate,
            callback: function callback($$v) {
              _vm.returnedDate = $$v;
            },
            expression: "returnedDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2307618401)
  })], 1)] : [_c('b-form-group', {
    attrs: {
      "label": "Return Date",
      "label-for": "returned-date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "return date",
      "vid": "returned_date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-datepicker', {
          attrs: {
            "id": "returned-date",
            "locale": "en-US",
            "reset-button": "",
            "today-button": "",
            "close-button": "",
            "placeholder": "Select Return Date"
          },
          model: {
            value: _vm.returnedDate,
            callback: function callback($$v) {
              _vm.returnedDate = $$v;
            },
            expression: "returnedDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Purpose ",
      "label-for": "purpose"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "purpose",
      "vid": "purpose",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-textarea', {
          model: {
            value: _vm.purpose,
            callback: function callback($$v) {
              _vm.purpose = $$v;
            },
            expression: "purpose"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isAssetAssignUserFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }